import { render, staticRenderFns } from "./StockArticleDot.vue?vue&type=template&id=0343de91&scoped=true"
import script from "./StockArticleDot.vue?vue&type=script&lang=js"
export * from "./StockArticleDot.vue?vue&type=script&lang=js"
import style0 from "./StockArticleDot.vue?vue&type=style&index=0&id=0343de91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0343de91",
  null
  
)

export default component.exports